import { useEffect, useState } from 'react';
import { supabase } from '../config/supabase';

export function useSpotifyAccount() {
  const [accountId, setAccountId] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      setAccountId(session?.user.id ?? null);
    });
    return () => data.subscription.unsubscribe();
  }, []);

  return accountId;
}
